import * as stylex from '@stylexjs/stylex';
import { clsx } from 'clsx';
import Icon from '../Icon/Icon';
import SvgIcon from '../SvgIcon/SvgIcon';
import { colors } from '../theme/colors.stylex';
import { isSvgIcon } from '../utils/svg';
import type { SeeqActionDropdownItems } from './SeeqActionDropdown.types';

const styles = stylex.create({
  createIcon: { fontSize: '1.375rem', color: colors.white, minWidth: '2.25rem' },
  createSvg: { padding: '0.25rem', height: '2.25rem', width: '2.25rem' },
  createRow: {
    display: 'flex',
    width: '37.5rem',
    flexDirection: 'row',
    gap: '1rem',
    padding: '0.625rem',
    paddingLeft: '1.25rem',
  },
  createIconContainer: {
    display: 'flex',
    height: '2.25rem',
    width: '2.25rem',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.1875rem',
    backgroundColor: colors.accent,
    marginTop: '0.375rem',
  },
  createText: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
  title: { fontSize: '20px', fontWeight: 600 },
  description: { fontSize: '0.8125rem', lineHeight: '1rem' },
  viewIcon: { fontSize: '1.25rem', color: colors.menuText },
  viewSvg: { width: '1rem' },
  view: { display: 'flex', flexDirection: 'column', padding: '0.625rem' },
  viewRow: { display: 'flex', flexDirection: 'row', alignItems: 'flex-end', gap: '0.5rem' },
  viewIconContainer: {
    display: 'flex',
    height: '1.25rem',
    width: '1.25rem',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0.1875rem',
  },
  viewLabel: { fontSize: '0.8125rem' },
  insert: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '0.625rem',
    textAlign: 'left',
    fontWeight: 400,
    color: colors.text,
  },
  insertTitle: {
    marginTop: '0.75rem',
    marginBottom: '0.5rem',
    fontSize: '0.9375rem',
    lineHeight: '1.125rem',
    fontWeight: 500,
    color: colors.accent,
  },
  insertDescription: { marginTop: '0.25rem', fontSize: '0.8125rem', color: colors.text },
});

export const SeeqActionDropdownItem = (item: SeeqActionDropdownItems) => {
  let renderIcon = <></>;
  if (item.icon) {
    renderIcon =
      typeof item.icon === 'string' && isSvgIcon(item.icon) ? (
        <SvgIcon
          {...item}
          icon={item.icon}
          extraClassNames={item.iconExtraClassNames}
          xstyle={[styles.createIcon, styles.createSvg, item.iconXstyle]}
        />
      ) : (
        <Icon
          icon={item.icon}
          type="text"
          extraClassNames={item.iconExtraClassNames}
          xstyle={[styles.createIcon, item.iconXstyle]}
        />
      );
  }

  const iconContainerProps = stylex.props(styles.createIconContainer, item.iconContainerXstyle);
  return (
    <div {...stylex.props(styles.createRow)}>
      <div {...iconContainerProps} className={clsx(iconContainerProps.className, item.iconContainerExtraClassNames)}>
        {renderIcon}
      </div>
      <div {...stylex.props(styles.createText)}>
        <div {...stylex.props(styles.title)}>{item.display}</div>
        <div {...stylex.props(styles.description)}>{item.text}</div>
      </div>
    </div>
  );
};

export const ViewWorkbench = (item: SeeqActionDropdownItems) => {
  let renderIcon = <></>;
  if (item.icon) {
    renderIcon =
      typeof item.icon === 'string' && isSvgIcon(item.icon) ? (
        <SvgIcon
          {...item}
          icon={item.icon}
          extraClassNames={item.iconExtraClassNames}
          xstyle={[styles.viewIcon, styles.viewSvg, item.iconXstyle]}
          type="default"
        />
      ) : (
        <Icon
          icon={item.icon}
          type="text"
          extraClassNames={item.iconExtraClassNames}
          xstyle={[styles.viewIcon, item.iconXstyle]}
        />
      );
  }

  return (
    <div {...stylex.props(styles.view)}>
      <div {...stylex.props(styles.viewRow)}>
        <div {...stylex.props(styles.viewIconContainer)}>{renderIcon}</div>
        <div {...stylex.props(styles.viewLabel)}>{item.display}</div>
      </div>
    </div>
  );
};

export const InsertSeeqContent = (item: SeeqActionDropdownItems) => {
  return (
    <div {...stylex.props(styles.insert)}>
      <h5 {...stylex.props(styles.insertTitle)}>{item.display}</h5>
      <div {...stylex.props(styles.insertDescription)}>{item.text}</div>
    </div>
  );
};
